export function stateValue(state) {
    const value = Number(state);
    return Number.isNaN(value) ? 0 : value;
}

export function isRunning(state) {
    const value = stateValue(state);
    return value === 15 || (value >= 1 && value <= 8);
}

export function isFinished(state) {
    return stateValue(state) === 9;
}

export function isCanceled(state) {
    return stateValue(state) === 10;
}

export function isFailed(state) {
    const value = stateValue(state);
    return value >= 11 && value <= 14;
}

export function progressValue(build) {
    const value = Number(build && build.progress);
    return Number.isNaN(value) ? 0 : value;
}

export function hasSyncCompleted(build) {
    const state = stateValue(build.state);
    const progress = progressValue(build);

    if (isCanceled(state) || isFailed(state)) {
        return !!(build.branch_to_build || build.codemagic_build_id);
    }

    return (state >= 1 && state <= 9) || progress >= 24;
}

export function getStepIcon(build, step) {
    const state = stateValue(build.state);
    if (step === 'sync') {
        if (state === 15) return 'fa fa-refresh fa-spin text-primary';
        if (hasSyncCompleted(build)) return 'fa fa-check text-success';
        if (isCanceled(state)) return 'fa fa-ban text-warning';
        if (isFailed(state)) return 'fa fa-times text-danger';
        return 'fa fa-circle-o text-muted';
    }
    if (step === 'build') {
        if (state >= 1 && state <= 8) return 'fa fa-circle-o-notch fa-spin text-primary';
        if (isFinished(state)) return 'fa fa-check text-success';
        if (isFailed(state) && hasSyncCompleted(build)) return 'fa fa-times text-danger';
        if (isCanceled(state)) return 'fa fa-ban text-warning';
        return 'fa fa-circle-o text-muted';
    }
}

export function getStepTextClass(build, step) {
    const state = stateValue(build.state);
    if (step === 'sync') {
        if (state === 15) return 'text-primary font-bold';
        if (hasSyncCompleted(build)) return 'text-success';
        if (isCanceled(state)) return 'text-warning';
        if (isFailed(state)) return 'text-danger';
        return 'text-muted';
    }
    if (step === 'build') {
        if (state >= 1 && state <= 8) return 'text-primary font-bold';
        if (isFinished(state)) return 'text-success';
        if (isFailed(state) && hasSyncCompleted(build)) return 'text-danger';
        if (isCanceled(state)) return 'text-warning';
        return 'text-muted';
    }
}

export function getBuildPhaseText(build) {
    const states = {
        1: 'Codemagic: Starting',
        2: 'Codemagic: Queued',
        3: 'Codemagic: Preparing',
        4: 'Codemagic: Fetching',
        5: 'Codemagic: Building',
        6: 'Codemagic: Testing',
        7: 'Codemagic: Publishing',
        8: 'Codemagic: Finishing',
        9: 'Codemagic: Finished',
        11: 'Codemagic: Failed',
        12: 'Codemagic: Failed',
        13: 'Codemagic: Failed',
        14: 'Codemagic: Failed',
    };
    const state = stateValue(build.state);
    if (state >= 1 && state <= 14 && state !== 10) {
        return states[state] || 'Codemagic Build';
    }
    return 'Codemagic Build';
}

export function statusBadgeClass(state) {
    if (isFinished(state)) {
        return 'label label-success';
    }
    if (isCanceled(state)) {
        return 'label label-warning';
    }
    if (isFailed(state)) {
        return 'label label-danger';
    }
    if (isRunning(state)) {
        return 'label label-warning';
    }
    return 'label label-default';
}
